import { Component } from '@angular/core';
// app.module.ts

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/app.component.ts